<template>
  <div>
    <div class="common-form">编辑场景</div>
    <el-form ref="form" :model="form" label-width="200px">
      <el-form-item label="场景名称" :rules="[{ required: true, message: '场景名称不能为空' }]" prop="sence_name">
        <el-input class="max-w460" v-model="form.sence_name"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">提交</el-button>

      </el-form-item>
    </el-form>
    <!--图片组件-->
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import AppSettingApi from "@/api/appsetting.js";
import Upload from "@/components/file/Upload";
export default {
  components: {
    Upload
  },
  data() {
    return {
      form: {
        sence_name: "",
        status: 1
      },
      sence_id: ""
    };
  },
  created() {
    this.sence_id = this.$route.query.sence_id;
    this.getData();
  },

  methods: {
    // 详情
    getData: function() {
      let self = this;
      AppSettingApi.senceDetail(
        {
          sence_id: self.sence_id
        },
        true
      )
        .then(res => {
          self.form = res.data.detail;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    // 修改技师
    onSubmit() {
      //
      let self = this;
      AppSettingApi.senceEdit(self.form, true)
        .then(res => {
          if (res.code == 1) {
            self.$message(res.msg);
          }
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style scoped lang=''>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/views/appsetting/jgpush/edit.vue